module.exports = __webpack_public_path__ + "img/logo.bf44b56c.svg";